export class PostGetLocationSearchRequest {
    facilityOrLocationName?: string;
    cityOrZip?: string;
    services?: string; // Comma-separated list
    types?: string; // Comma-separated list
    
    distanceInMiles?: number = 15;
    longitude?: number;
    latitude?: number;

    usePaging? : boolean = false;
    pageSize?: number = 10;
    pageIndex?: number = 0;
}